<template>
  <div v-if="howto" class="func-search-recommend-link">
    <span v-if="howto">
      <a v-on:click="clickLink()">
          <slot></slot>
        </a>
    </span>
  </div>
  <div v-else-if="isExist()" class="recommend_col col-xxs-6 col-xs-6 col-sm-6 col-md-3">
    <div class="recommend_item">
      <a v-on:click="clickLink()">
        <div class="thumbnail">
          <img :src="imageSource" alt="..."
            class="img-responsive center-block">
          <div class="caption">
            <h3 class="title items">
              <LabelFunMessage :fcontId="fcontId" msgkey="1" />
            </h3>
          </div>
        </div>
        <!--/thumbnail-->
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LabelFunMessage from './LabelFunMessage'
export default {
  name: 'FuncSearchRecommendLink',
  components: {
    LabelFunMessage
  },
  props: {
    fcontId: String,
    howto: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapState(['setupnavi', 'languageChangeCount', 'lg2']),
    ...mapState('articles', ['articles']),
    imageSource: function() {
      return process.env.VUE_APP_ROOT + '/assets/article' + this.fcontId + '/images/i7_small.jpg'
    }
  },
  methods: {
    clickLink: function() {
      // GA4
      if (this.howto) {
        this.$gtag.event("tap_button", {
          "custom_parameter1": "article_link",
          "custom_parameter2": this.fcontId
        })
      }else{
        this.$gtag.event("tap_button", {
          "custom_parameter1": "recommend",
          "custom_parameter2": this.fcontId
        })
      }
      
      this.$router.push({ 
        path: '/' + this.lg2 + '/articles/' + this.fcontId,
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
      })
    },
    isExist: function () {
      const test = this.articles.find((article) => this.fcontId == article.id);
      return test !== undefined;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3.title {
  font-size: 18px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.recommend_item, .recommend_item .thumbnail {
  height: 100%;
  margin-bottom: 0px;
}

@media (min-width: 767px) {
  .recommend_col {
    padding: 5px;
  }
}

@media (max-width: 767px) {
  h3.title {
    font-size: 14px;
  }

  .recommend_col {
    padding: 5px;
  }
}
</style>